// Override useContext method to wrap all the components with the given component
module.exports = (context, wrappedComponent) => {
  const ReactRailsUJS = require('react_ujs');

  const constructorFromRequireContextWithGlobalFallback = require('react_ujs/react_ujs/src/getConstructor/fromRequireContextWithGlobalFallback');

  Object.defineProperty(ReactRailsUJS, 'useContext', {
    value: function (requireContext) {
      this.getConstructor = function (className) {
        const constructor =
          constructorFromRequireContextWithGlobalFallback(requireContext);
        return wrappedComponent(constructor(className));
      };
    },
  });

  // eslint-disable-next-line react-hooks/rules-of-hooks
  ReactRailsUJS.useContext(context);

  return ReactRailsUJS;
};
